import { render, staticRenderFns } from "./postPreview.vue?vue&type=template&id=44fe68e2&scoped=true"
import script from "./postPreview.vue?vue&type=script&lang=js"
export * from "./postPreview.vue?vue&type=script&lang=js"
import style0 from "./postPreview.vue?vue&type=style&index=0&id=44fe68e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe68e2",
  null
  
)

export default component.exports